import { Outlet } from "react-router-dom";

/* eslint-disable-next-line */
export interface ReportsContainerPageProps {}

export function ReportsContainerPage(props: ReportsContainerPageProps) {
  return (
    <Outlet />
  );
}

export default ReportsContainerPage;
